import GetStore from 'store';
import { getDoneeIdFromQuery } from './GasRouterProvider';

/**
 * Validates doneeIdFromQuery against the Redux campuses store.
 * - No donee param → returns userDoneeId
 * - Campuses not loaded → trusts the URL param (first-load compatibility)
 * - Valid campus → returns doneeIdFromQuery
 * - Invalid campus → returns userDoneeId
 */
export const getValidatedDoneeId = (searchParams: URLSearchParams): number => {
    const doneeIdFromQuery = getDoneeIdFromQuery(searchParams);
    const state = GetStore().getState();
    const userDoneeId = state.User.user.doneeId;

    if (!doneeIdFromQuery) return userDoneeId;

    const campuses = state.Donee.campuses;
    if (!campuses) return doneeIdFromQuery;

    const isValidCampus = campuses.some((c) => c.id === doneeIdFromQuery);
    return isValidCampus ? doneeIdFromQuery : userDoneeId;
};
